import MainLayout from "../../layouts/MainLayout";
import PriorityPlannerTable from "./PriorityPlannerTable";
import {Outlet} from "react-router-dom";
import React from "react";

const PriorityPlannerPage = () => {
    return (<MainLayout>
        <div className="priority-planner-page">
            <PriorityPlannerTable />
            <Outlet />
        </div>
    </MainLayout>);
}

export default PriorityPlannerPage;